import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

type PaymentOrderSlice = CommonTableState;

const initialState: PaymentOrderSlice = {
    tableState: {
        resetIndicator: 0,
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        sorting: [{ id: "created", desc: true }],
        columnOrder: [
            "mrt-row-expand",
            "orderNumber",
            "offer",
            "paymentRequest.amount",
            "state",
        // Mockup v4: sloupec Faktura patri hned za Stav. Bez zapsani do columnOrder
        // ho TanStack na strankach s ulozenym stavem tabulky prilepi az na konec.
        "finalInvoiceOrderNumber",
            "targetType",
            "discountRate",
            "bonusCredits",
            "paymentRequest.periodStart",
            "paymentRequest.periodEnd",
            "created",
            "mrt-row-actions",
        ],
        density: "compact",
    },
};

export const paymentOrderSlice = createSlice({
    name: "paymentOrder",
    initialState: initialState,
    reducers: {
        updatePaymentOrderTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

// Action creators are generated for each case reducer function
export const { updatePaymentOrderTableState } = paymentOrderSlice.actions;

export default paymentOrderSlice.reducer;
